<!-- Sidenav -->
<div class="" (window:resize)="isMobile($event)">
  @if (!aspiranteLogueado) {
    <app-sidebar
      [ngClass]="{ 'sidenav fixed-left': isMobileResolution === false }"
    ></app-sidebar>
  }
  <div class="main-content">
    <!-- Top navbar -->
    <app-navbar></app-navbar>
    <!-- Breadcrum -->
    <app-breadcrum></app-breadcrum>
    <!-- Pages -->
    <router-outlet></router-outlet>
    <!-- Footer -->
    <app-footer></app-footer>
  </div>
</div>
